module.exports = __webpack_public_path__ + "img/3.404a9c8e.jpg";